import Odometer from './Odometer';
import React from 'react';
import _ from 'lodash';
import axios from 'axios';
import { Icon, Badge, Tooltip, Button, Modal } from 'antd';
import { calculateItemPrice, getCurrencySymbol } from 'alvarcarto-price-util';
import history from '../history';
import { createPosterImageUrl, createDesignerUrl } from '../util';
import config from '../config';

const PricePanel = React.createClass({
  getInitialState() {
    return {
      modalVisible: false,
      downloadUrl: null,
      modalClosable: false,
      downloadError: null,
    };
  },

  render() {
    const { globalState } = this.props;
    const mapItem = globalState.cart[globalState.editCartItem];
    const price = calculateItemPrice(mapItem, { onlyUnitPrice: true });
    const itemCount = _.reduce(globalState.cart, (memo, item) => memo + item.quantity, 0);

    const iconState = this.props.isOpen ? 'close' : 'setting';

    return (
      <div className="PricePanel">
        <div className="PricePanel__container">
          <Button
            icon={iconState}
            shape="circle"
            size="large"
            className="PricePanel__options"
            onClick={this._onOptionsClick} />
          <Button
            type="default"
            size="large"
            className="PricePanel__buy"
            onClick={this._onClickBuy}>Buy a map poster</Button>

          <Button
            type="primary"
            icon="download"
            size="large"
            className="PricePanel__download"
            onClick={this._onCheckoutClick}>Generate</Button>
        </div>

        {
          itemCount > 1
            ? <div className="PricePanel__badge">
                <Tooltip title={`You have ${itemCount} posters in your order.`}>
                  <Badge count={itemCount} />
                </Tooltip>
              </div>
            : null
        }

        <Modal
          visible={this.state.modalVisible}
          zIndex={9999999999}
          title={this._getModalTitle()}
          footer={this.state.downloadUrl !== null ? <Button size="large" onClick={() => this.setState({ modalVisible: false })}>
              Close
            </Button> : <div className="PricePanel__download-footer"></div>}
          onCancel={this._closeModal}
          closable={this.state.downloadUrl !== null || this.state.downloadError !== null}
        >
          <div>
            <div className="PricePanel__download-loading">
              {this._renderModalUpperContent()}
            </div>

            <p className="PricePanel__designer-link">
              By the way, we're also selling map posters and plywood prints. <br />
              Check out <a target="_blank" href={createDesignerUrl(mapItem)}>how your location would look as a poster <Icon type="export" /></a>.
              { this.state.downloadError !== null
                ? <span><br /><b>(we guarantee it works better than this)</b></span> : null }
            </p>
          </div>
        </Modal>
      </div>
    );
  },

  _onClickBuy() {
    const { globalState } = this.props;
    const mapItem = globalState.cart[globalState.editCartItem];
    const designerUrl = createDesignerUrl(mapItem);
    window.open(designerUrl, '_blank');
  },

  _closeModal() {
    if (this.state.downloadError !== null || this.state.downloadUrl !== null) {
      this.setState(() => ({ modalVisible: false }));
    }
  },

  _getModalTitle() {
    if (this.state.downloadError !== null) {
      return "Unexpected error"
    }

    return this.state.downloadUrl !== null ? "Your background is ready!" : "Preparing your background.."
  },

  _renderModalUpperContent() {
    if (this.state.downloadError !== null) {
      return <Icon className="PricePanel__error" type="frown-o" />
    }

    if (this.state.downloadUrl !== null) {
      return <Button
        type="primary"
        icon="download"
        size="large"
        className="PricePanel__download-final"
        onClick={this._onDownloadClick}
      >
        Download
      </Button>;
    }

    return <div className="PricePanel__flip-container">
      <div className="PricePanel__flipper">
        <div className="PricePanel__front">
          <Icon type="picture" />
        </div>
        <div className="PricePanel__back">
          <Icon type="camera-o" />
        </div>
      </div>
    </div>;
  },

  _onCheckoutClick(e) {
    e.preventDefault();

    this.setState(() => ({ modalVisible: true, downloadUrl: null, downloadError: null }));

    const { globalState } = this.props;
    const mapItem = globalState.cart[globalState.editCartItem];
    const newUrl = `${createPosterImageUrl(mapItem)}&apiKey=${globalState.apiKey}`;

    axios.get(newUrl, { timeout: 60000, maxRedirects: 0 })
      .then((res) => {
        const downloadUrl = `${config.REACT_APP_RENDER_API_URL}${res.data.path}`;
        this.setState(() => ({ downloadUrl }));
      })
      .catch((err) => {
        this.setState(() => ({ downloadError: err }));
      });
  },

  _onDownloadClick() {
    window.open(this.state.downloadUrl, '_blank');
  },

  _onOptionsClick() {
    this.props.onOptionsClick();
  }
});

export default PricePanel;



// WEBPACK FOOTER //
// ./src/components/PricePanel.js